<template>
    <v-card width="auto" tile>
        <v-form ref="form">
            <v-card-text>
              <v-row dense>
                <v-col cols="6">
                  <v-text-field
                    v-model="model.usuario"
                    label="usuario"
                    :rules="fieldRequired"
                    outlined
                    dense>
                  </v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="model.email"
                    label="Correo"
                    :rules="fieldRequired"
                    outlined
                    dense>
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="8" md="8">
                  <SearchEmployee :setterModel="model.empleado" :itemAction="fieldEmployed" :on-success="actionFieldData"/>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="model.password"
                    label="Contraseña"
                    type="password"
                    :rules="fieldRequired"
                    outlined
                    dense>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="model.confirmpassword"
                    label="Confirmar Contraseña"
                    type="password"
                    :rules="fieldRequired"
                    outlined
                    dense>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-alert type="error" v-if="show">
                {{message}}
              </v-alert>

            </v-card-text>
            <v-card-actions>
                <v-layout justify-end>
                <v-btn class="red darken-1 mr-3" dark @click="onCancel">Cancelar</v-btn>
                <v-btn class="green darken-1 mr-3" dark @click="save"> Guardar</v-btn>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import SearchEmployee from '@/components/fields/searchEmployee'
import { Validate } from '@/mixins/validateFormMixin'
export default {
  name: 'UserFormCreate',
  mixins: [Validate],
  props: ['model', 'onSuccess', 'onCancel'],
  data: () => ({
    message: '',
    show: false,
    fieldEmployed: {
      name: 'Empleado',
      nameid: 'empleado_id',
      url: '/empresa/empleados/find'
    }
  }),
  components: {
    SearchEmployee
  },
  methods: {
    actionFieldData (obj) {
      this.model[obj.id] = (obj.data === undefined) ? null : obj.data
    },
    save () {
      if (this.$refs.form.validate()) {
        this.show = false
        this.message = ''
        if (this.model.password === this.model.confirmpassword) {
          this.onSuccess(this.model)
        } else {
          this.show = true
          this.message = 'Contraseña no Coincide'
        }
      } else {
        this.show = true
        this.message = 'Campos Obligatorios'
      }
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain'])
  }

}
</script>

<style>

</style>
